import type { ReactNode } from "react";

/**
 * Break-glass: the frame of the manage-contacts card — a replica of the legacy
 * Cargo Box (Medium shadow).
 *
 * ui-core's Panel is the card primitive, but it is a different card: square
 * corners and a hard offset shadow. This one is the 3px-radius, soft-shadow
 * Cargo box the customer-facing screens still use (same literals as
 * `Features/Brokers/CustomComponents/BrokersBox`), plus a height floor so the
 * card doesn't resize as the contact's details change length. Neither the
 * shadow nor the floor is expressible through a component prop.
 */
export function ContactsCardBox({ children }: { children: ReactNode }) {
  return (
    <div className="relative min-h-[208px] w-full rounded-[3px] border border-border-strong p-8 shadow-[var(--color-shadow-ambient)_0px_3px_12px]">
      {children}
    </div>
  );
}
